import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useDeleteSeed } from '@/hooks/use-seeds';
import { toast } from 'sonner';
import { toToastMessage } from '@/lib/api-error';

interface DeleteSeedDialogProps {
  seedId: string;
  seedTitle: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleted?: () => void;
}

export function DeleteSeedDialog({
  seedId,
  seedTitle,
  open,
  onOpenChange,
  onDeleted,
}: DeleteSeedDialogProps) {
  const mutation = useDeleteSeed();

  const handleDelete = () => {
    mutation.mutate(seedId, {
      onSuccess: () => {
        toast.success('Seed deleted');
        onOpenChange(false);
        onDeleted?.();
      },
      onError: (err) => {
        toast.error(toToastMessage(err, 'Failed to delete seed'));
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Seed</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete &quot;{seedTitle}&quot;? This action cannot be undone.
            Seeds that have been assigned or used for personalized practices cannot be deleted.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose render={<Button variant="outline" />}>
            Cancel
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={mutation.isPending}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
